import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { connect } from 'react-redux';
import { Button } from '@surfline/quiver-react';
import config from '../../config';
import brandToString from '../../utils/brandToString';
import { trackEvent, navigatedToPage } from '../../redux/actions/segmentEvents';
import {
  GiftCardSelector,
  GiftCard,
  GiftCardMessageForm,
  GiftMessage,
  GiftPaymentForm,
  GiftDisclaimer,
} from '../../components';
import { saveGift, selectGiftProduct, editGift, purchaseGift } from '../../redux/actions/gifts';
import { getGiftProducts, getSelectedGiftProduct } from '../../selectors/gifts';

class GiftCardsWrapper extends Component {
  constructor(props) {
    super(props);
    this.viewedGiftPurchase = this.viewedGiftPurchase.bind(this);
  }

  componentDidMount() {
    this.props.doNavigatedToPage('Funnel', 'Gift Purchase', {}, { Wootric: false });
    this.props.doTrackEvent('Viewed Gift Purchase Step', { step: 1 });
  }

  viewedGiftPurchase(step) {
    this.props.doTrackEvent('Viewed Gift Purchase Step', step);
  }

  renderSuccessButton = () => {
    this.viewedGiftPurchase({ step: 3 });
    return (
      <div className="gift-purchase-success__button">
        <Button onClick={() => window.location.assign(config[`${brandToString(config.company).toLowerCase()}Home`])}>
          {`RETURN TO ${brandToString(config.company)}`}
        </Button>
      </div>
    );
  }


  render() {
    const {
      giftProducts,
      selectedProduct,
      doSelectGiftProduct,
      doSaveGift,
      savedGiftData,
      doEditGift,
      showPaymentForm,
      submitting,
      doPurchaseGift,
      error,
      purchaseSuccess,
    } = this.props;
    return (
      <div>
        {
          showPaymentForm || purchaseSuccess ?
            <div>
              <div className="saved-gift-card-container">
                <div className="gift-card-wrapper">
                  <GiftCard giftProduct={selectedProduct} />
                </div>
                <GiftMessage savedGiftData={savedGiftData} doEditGift={doEditGift} purchaseSuccess={purchaseSuccess} />
              </div>
              {
                showPaymentForm ?
                  <StripeProvider apiKey={config.stripe.publishableKey}>
                    <Elements>
                      <GiftPaymentForm
                        submitting={submitting}
                        savedGiftData={savedGiftData}
                        selectedProduct={selectedProduct}
                        purchase={doPurchaseGift}
                        error={error}
                        viewedGiftPurchase={this.viewedGiftPurchase}
                      />
                    </Elements>
                  </StripeProvider>
                  : this.renderSuccessButton()
              }
            </div>
            :
            <div>
              <GiftCardSelector
                giftProducts={giftProducts}
                selectedProductId={selectedProduct._id}
                doSelectGiftProduct={doSelectGiftProduct}
              />
              <GiftCard giftProduct={selectedProduct} />
              <GiftCardMessageForm
                action={doSaveGift}
                selectedProductId={selectedProduct._id}
                savedGiftData={savedGiftData}
              />
            </div>
        }
        <GiftDisclaimer />
      </div>
    );
  }
}

GiftCardsWrapper.propTypes = {
  doSelectGiftProduct: PropTypes.func.isRequired,
  doSaveGift: PropTypes.func.isRequired,
  doEditGift: PropTypes.func.isRequired
};
export default connect(
  state => ({
    giftProducts: getGiftProducts(state),
    selectedProduct: getSelectedGiftProduct(state),
    submitting: state.interactions.submitting,
    ...state.gifts
  }),
  dispatch => ({
    doSelectGiftProduct: selectedProductId => dispatch(selectGiftProduct(selectedProductId)),
    doSaveGift: form => dispatch(saveGift(form)),
    doEditGift: () => dispatch(editGift()),
    doPurchaseGift: giftcard => dispatch(purchaseGift(giftcard)),
    doTrackEvent: (name, properties) => dispatch(trackEvent(name, properties)),
    doNavigatedToPage: (name, category, properties, integrations) =>
      dispatch(navigatedToPage(name, category, properties, integrations)),
  }),
)(GiftCardsWrapper);
